import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 100px;
`;

export const ListWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 15px;
`;

export const ItemWrapper = styled.div`
  width: 100%;
  background-color: white;
  padding: 10px 13px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid black;
  .data {
    height: fit-content;
    width: calc(100% - 150px);
    .name {
    }
  }
  .rightside {
    height: fit-content;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
`;

const expenseColor = {
  part: "linear-gradient( 135deg, #FFF720 10%, #3CD500 100%);",
  //   repairer: "linear-gradient( 135deg, #E2B0FF 10%, #9F44D3 100%)",
  repairer: "linear-gradient( 135deg, #F6D242 10%, #FF52E5 100%);",
  default: "linear-gradient( 135deg, #E2B0FF 10%, #9F44D3 100%)",
};
const imgWidth = 40;
export const ImgWrapper = styled.div`
  width: ${imgWidth}px;
  height: ${imgWidth}px;
  
  /* padding: 10px; */
  img {
    border-radius: 50%;
    border: 1px solid black;
    /* border-radius: 10px; */
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const AddListWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  /* margin: auto; */
  /* gap: 20px; */
  /* position: fixed;
  left: 0;
  right: 0;
  bottom: 15px; */
  background-color: white;
  padding: 10px;
  border-radius: 
  /* 40px 40px  */ 15px 15px;
  border: 1px solid black;
  /* margin: 10px 15px; */
`;

export const AddButton = styled.div`
  /* height: fit-content; */
  border-radius: 50px 50px 15px 15px;
  text-align: center;
  /* margin: auto; */
  img {
    width: 50px;
    border: ${({ active }) =>
      active ? "3px solid #1677ff" : "1px solid black"};
    /* width: 100%; */
    height: 50px;
    border-radius: 50%;
  }
  .price {
    /* background-color: lightgray; */
    border: ${({ active }) =>
      active ? "2px solid #1677ff" : "1px solid black"};
    width: fit-content;
    margin: auto;
    border-radius: 10px;
    padding: 0 5px;
  }
`;
